import FileTransferTask from "./FileTransferTask";

/**
 * @class InfoDialog
 */
export default class FileTransferOutTask extends FileTransferTask {
    /**
     * @param {String}          name
     * @param {String}          format
     * @param {Object}          formatOptions
     * @param {String}          protocol
     * @param {Object}          protocolOptions
     * @param {String}          startType
     */
    constructor(name, format, formatOptions, protocol, protocolOptions, startType) {
        super(name, format, formatOptions, protocol, protocolOptions);

        this._startType = startType;
    }

    /**
     * @return {String}
     */
    get startType() {
        return this._startType;
    }

    /**
     * @return  {Object}
     */
    formatTask = () => {
        return {
            name: this._name,
            format: this._format,
            format_options: this._formatOptions,
            protocol: this._protocol,
            protocol_options: this._protocolOptions,
            start_type: this._startType
        };
    };
}
